<template>
  <div>
    <mdb-row>
      <mdb-col md="8">
        <div class="sub-title"><mdb-icon icon="bell" /> 공지사항</div>
        <notification :perPage="5"/>
      </mdb-col>
      <mdb-col md="4">
        <div class="sub-title"><mdb-icon icon="calendar-alt" /> 평가 일정</div>
        <test-schedule/>
      </mdb-col>
    </mdb-row>
    <stduent-summary />
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Notification from '@/views/common//notification/Notification.vue';
import Board from '@/views/common/board/Board.vue';

import Summary from '@/models/Summary'
import StduentSummary from '../../../components/summary/StduentSummary.vue';
import TestSchedule from '../../../components/summary/TestSchedule.vue';
export default {
  name: 'StudentHomePage',
  components: { Notification, StduentSummary, TestSchedule },
  computed: {
    ...mapState('auth', ['profile']),
    ...mapState('training', ['training'])
  }
}
</script>
